import { render, staticRenderFns } from "./XTabs.vue?vue&type=template&id=43f84a27&scoped=true&"
import script from "./XTabs.vue?vue&type=script&lang=js&"
export * from "./XTabs.vue?vue&type=script&lang=js&"
import style0 from "./XTabs.vue?vue&type=style&index=0&id=43f84a27&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f84a27",
  null
  
)

export default component.exports